<template>
  <b-card no-body class="section-actions">
    <header class="actions-header">
      <h3 class="actions-title">Ações</h3>
      <span class="actions-subtitle">Ações administrativas sobre esta conta</span>
    </header>

    <div class="actions-grid">
      <base-button
        @click="$emit('release-plan')"
        block
        success
      >
        Liberar plano
      </base-button>

      <base-button
        @click="$emit('change-phone', user)"
        block
        success
      >
        Atualizar telefone
      </base-button>

      <base-button
        @click="$emit('change-cpf', user)"
        block
        success
      >
        Atualizar CPF
      </base-button>

      <base-button
        @click="$emit('select-date-exemption-authentication', user)"
        block
        success
      >
        Liberar autenticação
      </base-button>

      <base-button
        @click="$emit('select-extra-access-date', user)"
        block
        success
      >
        Atualizar dias extra de acesso
      </base-button>

      <base-button
        @click="$emit('change-user-profile', user)"
        block
        success
      >
        Alterar perfil do usuário
      </base-button>

      <base-button
        v-if="user && user.role === 'admin'"
        @click="goToRouter('/funcionalidades')"
        block
        success
      >
        Funcionalidades
      </base-button>

      <base-button
        @click="$emit('transfer-files-between-users', user)"
        block
        success
      >
        Transferir os arquivos entre usuários
      </base-button>

      <base-button
        @click="$emit('trial-plan')"
        block
        success
        :disabled="user.usedTrial && user.usedTrial.length > 0"
        :title="user.usedTrial && user.usedTrial.length > 0 ? 'Usuário já utilizou o teste grátis' : null"
      >
        Liberar teste grátis
      </base-button>

      <base-button
        @click="$emit('block-user', {
          email: user.username,
          block: user.block,
          _id: user._id
        })"
        :class="{ blocked: user.block }"
        block
        danger
      >
        {{user.block ? 'Desbloquear usuário' : 'Bloquear usuário'}}
      </base-button>

      <base-button
        @click="$emit('delete-account', user)"
        block
        danger
      >
        Excluir conta
      </base-button>
    </div>
  </b-card>
</template>

<script>

export default {
  name: 'SectionActions',
  props: {
    user: { type: Object, required: true }
  },
  methods: {
    goToRouter(router) {
      this.$router.push({ path: router, query: {usuario: this.user._id} })
    },
  },
  emits: ['trial-plan', 'release-plan']
}
</script>

<style lang="scss" scoped>
$green-text: #1e7e34;
$muted: #8a8f94;
$border: #e6e8ea;

.section-actions {
  border: 1px solid $border;
  border-radius: 8px;
  box-shadow: 0 1px 2px rgba(40, 167, 69, 0.1);
  padding: 16px 20px;
}

.actions-header {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 12px;
}

.actions-title {
  margin: 0;
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: $green-text;
}

.actions-subtitle {
  font-size: 12px;
  color: $muted;
}

.actions-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 8px;
}

.block-user {
  opacity: 0.7 !important;

  &.blocked {
    opacity: 1 !important;
  }
}
</style>
